import { PREVIEW_ROW_ATTRIBUTE } from '~/components/rowPreview/useRowPreview';

export type TaskHover = ((taskId: string | null) => void) | undefined;

export const previewRowProps = (taskId: string, onHover: TaskHover) => ({
  [PREVIEW_ROW_ATTRIBUTE]: '',
  'data-id': taskId,
  onMouseEnter: onHover ? () => onHover(taskId) : undefined,
  onMouseLeave: onHover ? () => onHover(null) : undefined,
});
